import React from 'react'
import styled from 'styled-components'

import Div from '@jarvis.oddle/core/components/Div'
import Flex from '@jarvis.oddle/core/components/Flex'
import { Text } from '@jarvis.oddle/core/components/Typo'
import Form from '@jarvis.oddle/core/components/Form'

import breakpoint from 'src/utils/styledComponentsBreakpoint'
import { borderRadiusSizes } from '@jarvis.oddle/core/theme/default'
import { languages } from '@jarvis.oddle/core/tools/localisation'
import { lightenOrDarken } from '@jarvis.oddle/core/tools/style'

const StyledText = styled(Text)`
  margin-left: 12px;
`

const RadioGroupContainer = styled(Div)`
  width: 100%;
  height: 100%;
`

const RadioContainer = styled(Flex).attrs(() => ({
  borderRadius: borderRadiusSizes.medium
}))`
  align-items: baseline;
  margin: 2px 6.5px;
  padding: 14px 28.5px;
  background-color: ${(props) =>
    props.checked &&
    lightenOrDarken(
      props.backgroundColor || props.theme.colorContainerColor,
      10
    )};
  cursor: pointer;

  ${breakpoint('desktop')`
    margin: 0;
    padding: 14px 25px;
  `}
  & > div {
    border-color: ${(props) => props.textColor};
  }
`

const LanguageSelectionRadio = ({
  locale,
  locales,
  color,
  backgroundColor
}: {
  locale: string
  locales: string[]
  color?: string
  backgroundColor?: string
}) => (
  <Form.RadioGroup
    name='locale'
    selected={locale}
    Container={RadioGroupContainer}
  >
    {locales.map((localeInfo) => (
      <Form.Radio
        key={localeInfo}
        value={localeInfo}
        backgroundColor={backgroundColor}
        textColor={color}
        Container={RadioContainer}
        size='small'
      >
        <StyledText color={color}>{languages[localeInfo]}</StyledText>
      </Form.Radio>
    ))}
  </Form.RadioGroup>
)

const compareProps = (prevProps, nextProps) =>
  prevProps.locale === nextProps.locale

export default React.memo(LanguageSelectionRadio, compareProps)
